import {
  DEMAND_FETCHING,
  DEMAND_FAILED,
  DEMAND_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DEMAND_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case DEMAND_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case DEMAND_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
